"use client";

// Connect a platform slide-out — Figma 8301:73101.

import { Check, Xmark } from "iconoir-react";

import { cn } from "@/lib/utils";

import { PRODUCT_WIDGET_ASSETS } from "./assets";
import { ProductWidgetFrame, ScaledProductWidgetCanvas } from "./mock-frame";

function ShopifyLogo({ className }: { className?: string }) {
  return (
    <div className={cn("relative size-[17.438px] shrink-0", className)}>
      <img
        src={PRODUCT_WIDGET_ASSETS.shopify1}
        alt=""
        className="absolute inset-[0_4.86%_1.64%_8.33%] h-auto w-auto max-w-none"
        aria-hidden
      />
      <img
        src={PRODUCT_WIDGET_ASSETS.shopify2}
        alt=""
        className="absolute inset-[11.36%_9.03%_1.64%_64.73%] h-auto w-auto max-w-none"
        aria-hidden
      />
      <img
        src={PRODUCT_WIDGET_ASSETS.shopify3}
        alt=""
        className="absolute inset-[30.6%_49.82%_18.68%_20.3%] h-auto w-auto max-w-none"
        aria-hidden
      />
    </div>
  );
}

function ConnectedBadge() {
  return (
    <span className="inline-flex shrink-0 items-center gap-[4.65px] rounded-full bg-[#e8f5e9] px-[7px] py-[2.9px] text-[9.3px] leading-none font-medium text-[#1b7f3d]">
      <Check className="size-[9.3px]" strokeWidth={2.5} aria-hidden />
      Connected
    </span>
  );
}

function PlatformRow({
  icon,
  name,
  url,
}: {
  icon: React.ReactNode;
  name: string;
  url: string;
}) {
  return (
    <div className="flex w-full items-center gap-[8.719px] rounded-2xl border-[0.8px] border-[#e6e6e5] px-[11.625px] py-[8.719px]">
      <div className="flex min-w-0 flex-1 items-center gap-[8.719px]">
        {icon}
        <div className="min-w-0 flex-1">
          <p className="truncate text-[11.63px] leading-[1.4] font-medium text-[#0d0d0d]">
            {name}
          </p>
          <p className="truncate text-[8.72px] leading-[1.4] text-[#737373]">
            {url}
          </p>
        </div>
      </div>
      <ConnectedBadge />
    </div>
  );
}

export function ConnectPlatformWidget({ className }: { className?: string }) {
  return (
    <ProductWidgetFrame className={className}>
      <ScaledProductWidgetCanvas>
        <div
          className="absolute top-1/2 flex w-[469.379px] -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-[10.477px] border-[0.727px] border-[#e6e6e5] bg-white"
          style={{ left: "calc(50% + 79.52px)" }}
        >
          <div className="flex shrink-0 items-center gap-[11.625px] border-b-[0.727px] border-[#e6e6e5] py-[14.532px] pr-[11.625px] pl-[17.438px]">
            <span className="flex size-[29.064px] shrink-0 items-center justify-center rounded-full border-[1.09px] border-[#d9d9d9] bg-white shadow-[0px_2.906px_0.727px_-2px_rgba(0,0,0,0.06)]">
              <Xmark
                className="size-[17.438px] text-[#0d0d0d]"
                strokeWidth={1.5}
                aria-hidden
              />
            </span>
            <p className="min-w-0 flex-1 text-[14.53px] leading-[1.2] font-medium text-[#0d0d0d]">
              Connect a platform
            </p>
          </div>

          <div className="flex w-full flex-col gap-[17.438px] p-[17.438px]">
            <div className="flex w-full flex-col gap-[5.813px]">
              <div className="flex items-end gap-[2.906px] leading-[1.4] whitespace-nowrap">
                <p className="text-[11.625px] font-medium text-[#0d0d0d]">
                  Connected stores
                </p>
                <p className="text-[10.172px] text-[#707070]">3</p>
              </div>

              <PlatformRow
                name="Nord Store"
                url="nord.myshopify.com"
                icon={<ShopifyLogo />}
              />
              <PlatformRow
                name="Nord Store"
                url="nord.amazon.com"
                icon={
                  <img
                    src={PRODUCT_WIDGET_ASSETS.amazon}
                    alt=""
                    className="size-[17.438px] shrink-0"
                    aria-hidden
                  />
                }
              />
            </div>
          </div>

          <div className="flex shrink-0 flex-col justify-center gap-[11.625px] border-t-[0.727px] border-[#e6e6e5] px-[17.438px] py-[14.532px]">
            <span
              aria-hidden
              className="border-pulse-700 text-pulse-700 inline-flex w-fit rounded-full border bg-white px-[14.53px] py-[7.26px] text-[12px] leading-none font-medium"
            >
              Confirm
            </span>
          </div>
        </div>

        <div
          className="pointer-events-none absolute flex items-center justify-center"
          style={{
            left: 318,
            top: 326.87,
            width: 40.598,
            height: 46.024,
          }}
        >
          <div className="-rotate-[15deg]">
            <img
              src={PRODUCT_WIDGET_ASSETS.cursor}
              alt=""
              className="h-[39.2px] w-[31.527px]"
              aria-hidden
            />
          </div>
        </div>
      </ScaledProductWidgetCanvas>
    </ProductWidgetFrame>
  );
}
